import React from "react"
import { Link } from "react-router-dom";
import SibaBreadcrumb from "../components/common/SibaBreadcrumb";
import SibaTitoloPagina from "../components/common/SibaTitoloPagina";
import { getPath } from "../services/api"
import * as Constants from '../utils/constants'
import { isPresentAuthenticatedUser } from "../utils/utilities";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Icon,
  CardTitle,
  CardText,
} from 'design-react-kit';


export function Home() {
 
  return (
    <main>
      <SibaBreadcrumb />
      {!isPresentAuthenticatedUser() ? (
        <Container className="px-2 my-2" id="lista-links" tag="section">
          <Row>
            <Col xs='12' lg='6'>
              <Card spacing className='card-bg card-big card-home'>
                <CardBody>
                <a href={getPath() + Constants.URL_CALCOLAPAGA_PUBLIC} title="Vai alla sezione calcola e paga">
                  <div className='top-icon'>
                    <Icon icon='it-card' id="icon1" role="presentation" alt="Icona carta di credito - Calcola e paga"/>
                  </div>
                  <CardTitle tag='h5'>
                    Calcola e Paga
                  </CardTitle>
                  <CardText>
                    In questa sezione è possibile effettuare calcoli e pagamenti.
                  </CardText>
                    <Icon
                      className=""
                      color=""
                      icon="it-arrow-right-circle"
                      size=""
                      alt="Icona"
                      role="presentation"
                      id="arrow1"
                    />
                  </a>
                </CardBody>
              </Card>
            </Col>
            <Col xs='12' lg='6'>
              <Card spacing className='card-bg card-big card-home'>
                <CardBody>
                  <div className='top-icon'>
                    <Icon icon='it-files' id="icon2" alt="Icona fogli - Paga tramite avviso bonario" role="presentation"/>
                  </div>
                  <CardTitle tag='h5'>
                    Paga tramite avviso bonario
                  </CardTitle>
                  <CardText>
                    Se hai ricevuto un avviso bonario clicca qui per effettuare il pagamento.
                  </CardText>
                  <a href={Constants.URL_EXT_PAGAMENTO_MOD3} target="_blank" title="Vai al sito dei pagamenti di Regione Liguria">
                    <Icon
                      className=""
                      color=""
                      icon="it-arrow-right-circle"
                      size=""
                      alt="Icona"
                      role="presentation"
                      id="arrow2"
                    />
                  </a>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <Container className="px-2 my-2" id="lista-links" tag="section">
          <Row>
            <Col xs='12' lg='6'>
              <Card spacing className='card-bg card-big card-home'>
                <CardBody>
                <a className="home-link" href={getPath() + Constants.URL_CONSULTAZIONE_PROTECTED} title="Vai alla sezione consulta e paga">
                  <div className='top-icon'>
                    <Icon className='home-icon' icon='it-search' id="icon1" alt="Icona lente - Consulta e paga" role="presentation"/>
                  </div>
                  <CardTitle className="home-link" tag='h5'>
                    Consulta e Paga
                  </CardTitle>
                  <CardText className="home-link">
                  In questa sezione è possibile verificare la situazione di autoveicoli, motoveicoli e rimorchi di proprietà negli ultimi cinque anni
                  </CardText>
                    <Icon
                      className="home-icon"
                      color=""
                      icon="it-arrow-right-circle"
                      size=""
                      alt="Icona"
                      role="presentation"
                      id="arrow1"
                    />
                  </a>
                </CardBody>
              </Card>
            </Col>
            <Col xs='12' lg='6'>
              <Card spacing className='card-bg card-big card-home'>
                  <CardBody>
                  <a className="home-link" href={getPath() + Constants.URL_CALCOLAPAGA_PROTECTED} title="Vai alla sezione Calcola e Paga">
                  <div className='top-icon'>
                    <Icon className='home-icon' icon='it-card' id="icon2" alt="Icona carta di credito - Calcola e paga" role="presentation"/>
                  </div>
                  <CardTitle className="home-link" tag='h5'>
                    Calcola e Paga
                  </CardTitle>
                  <CardText className="home-link">
                    In questa sezione è possibile effettuare calcoli e pagamenti per tutti i tipi di veicolo
                  </CardText>
                    <Icon
                      className="home-icon"
                      color=""
                      icon="it-arrow-right-circle"
                      size=""
                      alt="Icona"
                      role="presentation"
                      id="arrow2"
                    />
                  </a> 
                </CardBody>
             </Card>
            </Col>
          </Row>
          <Row>      
            <Col xs='12' lg='6'>
              <Card spacing className='card-bg card-big card-home'>
                <CardBody>
                <a className="home-link" href={getPath() + Constants.URL_RIMBORSI_PROTECTED} title= "Chiedi Rimborso">
                  <div className='top-icon'>
                    <Icon className='home-icon' icon='it-restore' id="icon3" alt="Icona ripristina - Chiedi Rimborso" role="presentation"/>
                  </div>
                  <CardTitle className="home-link" tag='h5'>
                    Chiedi un rimborso
                  </CardTitle>
                  <CardText className="home-link">
                    In questa sezione è possibile richiedere il rimborso di un pagamento effettuato
                  </CardText>
                    <Icon
                      className="home-icon"
                      color=""
                      icon="it-arrow-right-circle"
                      size=""
                      alt="Icona"
                      role="presentation"
                      id="arrow3"
                    />
                </a>
                </CardBody>
              </Card>
            </Col>
            <Col xs='12' lg='6'>
              <Card spacing className='card-bg card-big card-home'>
                <CardBody>
                <a className="home-link" href={Constants.URL_EXT_PAGAMENTO_MOD3} target="_blank" title= "Vai al sito dei pagamenti di Regione Liguria">
                <div className='top-icon'>
                    <Icon className='home-icon' icon='it-files' id="icon4" alt="Icona fogli - Paga avviso bonario" role="presentation"/>
                  </div>
                  <CardTitle className="home-link" tag='h5'>
                    Paga avviso bonario
                  </CardTitle>
                  <CardText className="home-link">
                    Se hai ricevuto un avviso bonario clicca qui per effettuare il pagamento.
                  </CardText>
                     <Icon
                      className="home-icon"
                      color=""
                      icon="it-arrow-right-circle"
                      size=""
                      alt="Icona"
                      role="presentation"
                      id="arrow4"
                    />
                  </a>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>)
      }
    </main>
  );
}